import React from 'react';

import classNames from 'classnames';

import styles from './style.less';

/**
 * Column header for Ant Design Table that pairs a small leading icon
 * (resolved through `iconForField` / `iconForColumn`) with the regular
 * label. Used by the classic ListView when wrapped from `byList`
 * modern, so card and table surfaces speak the same visual language
 * for each field.
 *
 * Falls back to the bare label when no icon is provided so legacy
 * call sites that bypass the icon pipeline keep working unchanged.
 */
const ColumnHeader = ({ icon: Icon, label, className }) => {
  if (!Icon) {
    return <span className={classNames(styles.header, className)}>{label}</span>;
  }
  return (
    <span className={classNames(styles.header, className)}>
      <Icon className={styles.headerIcon} aria-hidden />
      <span className={styles.headerLabel}>{label}</span>
    </span>
  );
};

export default ColumnHeader;
